import { gql } from '@apollo/client'

export const GET_QUOTES_COUNT = gql`
  query GetQuotesCount {
    getQuotesCount {
      count
    }
  }
`
